import React, { useState, useRef } from 'react';
import { CaretDown, Check } from '@phosphor-icons/react';
import { MOVE_IN_OPTIONS } from '../../../lib/constants';
import { cn } from '../../../lib/utils';
import { FilterPanel } from './FilterPanel';
interface MoveInDropdownProps {
  selected: string;
  specificMonth: string | null;
  onChange: (selected: string, specificMonth: string | null) => void;
  resultCount: number;
}
export function MoveInDropdown({
  selected,
  specificMonth,
  onChange,
  resultCount
}: MoveInDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const handleSelect = (value: string) => {
    if (value === 'specific') {
      // Keep open to select month
      onChange(value, specificMonth);
    } else {
      onChange(value, null);
      // Single-select non-specific: auto-close on desktop popover; on mobile
      // the user can also tap "Vezi N chiriași" or X.
      setIsOpen(false);
    }
  };
  const handleMonthSelect = (month: string) => {
    onChange('specific', month);
    setIsOpen(false);
  };
  const getLabel = () => {
    if (selected === 'specific' && specificMonth) return specificMonth;
    const opt = MOVE_IN_OPTIONS.find(o => o.value === selected);
    return opt ? opt.label : 'Oricând';
  };
  const getNext12Months = () => {
    const months = [];
    const d = new Date();
    for (let i = 0; i < 12; i++) {
      const monthStr = d.toLocaleString('ro-RO', {
        month: 'long',
        year: 'numeric'
      });
      months.push(monthStr.charAt(0).toUpperCase() + monthStr.slice(1));
      d.setMonth(d.getMonth() + 1);
    }
    return months;
  };
  const isActive = selected !== 'any';
  const handleClear = () => onChange('any', null);
  return <div className="relative min-w-0 sm:flex-1" ref={ref} data-id="element-2427">
      <button type="button" onClick={() => setIsOpen(!isOpen)} className={cn('w-full h-10 px-4 rounded-xl border text-sm flex items-center justify-between gap-2 transition-colors cursor-pointer', isActive ? 'bg-dark-2 border-lime-1 text-lime-1' : 'bg-dark-3 border-dark-4 text-light-2 hover:border-light-4')} data-id="element-2428">
        <span className="truncate min-w-0" data-id="element-2429">{getLabel()}</span>
        <CaretDown size={14} className={cn('shrink-0 transition-transform', isOpen && 'rotate-180')} data-id="element-2430" />
      </button>

      <FilterPanel isOpen={isOpen} onClose={() => setIsOpen(false)} title="Când vrei să te muți?" anchorRef={ref} desktopWidthClass="sm:w-64" resultCount={resultCount} secondaryAction={isActive ? {
      label: 'Resetează',
      onClick: handleClear
    } : null} data-id="element-2431">
        <div className="p-2 space-y-1" data-id="element-2432">
          {MOVE_IN_OPTIONS.map(opt => <button key={opt.value} type="button" onClick={() => handleSelect(opt.value)} className="w-full flex items-center justify-between px-3 py-2 rounded-lg hover:bg-dark-3 transition-colors text-left" data-id="element-2433">
              <span className={cn('text-sm', selected === opt.value ? 'text-lime-1 font-medium' : 'text-light-2')} data-id="element-2434">
                {opt.label}
              </span>
              {selected === opt.value && <Check size={14} weight="bold" className="text-lime-1" data-id="element-2435" />}
            </button>)}
        </div>

        {selected === 'specific' && <div className="border-t border-dark-4 p-2 bg-dark-3/30" data-id="element-2436">
            <div className="text-xs font-medium text-light-4 px-3 py-1 mb-1" data-id="element-2437">
              Alege luna
            </div>
            <div className="space-y-1" data-id="element-2438">
              {getNext12Months().map(month => <button key={month} type="button" onClick={() => handleMonthSelect(month)} className={cn('w-full px-3 py-1.5 rounded-lg text-sm text-left transition-colors', specificMonth === month ? 'bg-lime-1/10 text-lime-1 font-medium' : 'text-light-2 hover:bg-dark-3 hover:text-light-1')} data-id="element-2439">
                  {month}
                </button>)}
            </div>
          </div>}
      </FilterPanel>
    </div>;
}